export const environment = {
  production: true,
  apiPrefix: '/ws/',
  socketPrefix: '',
  language: 'en',
  appVersion: require('../../package.json').version
};
